import React, { useState } from "react";
import Dropzone from "react-dropzone";
import Axios from "axios";

const Quizzes = () => {
	const [description, setDescription] = useState("");
	const [files, setFiles] = useState(null);
	const [results, setResults] = useState(null);

	const createQuiz = () => {
		Axios.post(
			"https://aqua-question-generator.eastus.cloudapp.azure.com/quiz/wiki",
			{
				query: description,
			}
		).then((res) => {
			setResults(res.data.results);
		});
	};

	return (
		<div className="Quizzes">
			<div className="create-quiz">
				<div className="create-quiz-title">CREATE A QUIZ</div>
				<div className="create-quiz-desc">
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Ex
					consequuntur mollitia, adipisci eius iure laudantium
					doloremque atque distinctio placeat neque officia a
					voluptate labore debitis quaerat eligendi. Officia, dolores
					minus?
				</div>
				<div className="create-quiz-form">
					
					<label htmlFor="description">Word for Quiz</label>
					<input
						type="text"
						id="name"
						value={description}
						onChange={(e) => setDescription(e.target.value)}
					/>
					<label className="or" htmlFor="OR">
						{" "}
						OR
					</label>
					<div className="dropzone-container">
						<div className="dropzone-title">Upload Files</div>
						<Dropzone
							onDrop={(files) => {
								setFiles(files);
								console.log(files);
							}}
							accept="image/*"
							minSize={1024}
							maxSize={3072000}>
							{({
								getRootProps,
								getInputProps,
								isDragActive,
								isDragAccept,
								isDragReject,
							}) => {
								const additionalClass = isDragAccept
									? "accept"
									: isDragReject
									? "reject"
									: "";

								return (
									<div
										{...getRootProps({
											className: `dropzone ${additionalClass}`,
										})}>
										<input {...getInputProps()} />
										<span>
											{isDragActive ? "📂" : "📁"}
										</span>
										<p>
											Drag'n'drop images, or click to
											select files
										</p>
									</div>
								);
							}}
						</Dropzone>
						{files && (
							<div className="selected-file">
								Selected File : {files[files.length - 1].name}
							</div>
					)}
					</div>
					<button className="primary submit" onClick={createQuiz}>
						CREATE
					</button>
				</div>
				{results && (
					<div className="quiz-results">
						{results.map(({ question, answer }) => (
							<div key={question} className="quiz-result-item">
								<div className="question">
									<span className="question-text">
										Question : {" "}
									</span>
									{question}
								</div>
								<div className="answer">
									<span className="answer-text">
										Answer : {" "}
									</span>
									{answer}
								</div>
							</div>
						))}
					</div>
				)}
			</div>
		</div>
	);
};

export default Quizzes;
